import { EMRdetailsProps } from "@/api_framework/api_modals/EMRs";
import ImageUploadComponent from "@/app/components/ui/ImageUploadComponent";
import { useUpdateTempEMRAPI } from "@/app/hooks/api_hooks/emr/useUpdateTempEMRAPI";
import { useFileToS3LinkGeneratorAPI } from "@/app/hooks/api_hooks/LabReport/useFileToS3LinkGeneratorAPI";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

interface IFormValues {
  emr_images: Array<string>;
}
const ImageAttachmentComponent = ({ emrDetails }: EMRdetailsProps) => {
  const [uploadingFiles, setUploadingFiles] = useState<boolean>(false);

  const { execute: uploadToS3 } = useFileToS3LinkGeneratorAPI();

  const { execute: updateEmrAPI } = useUpdateTempEMRAPI();

  const params = new URLSearchParams(location.search);
  const emr_id = params.get("emr_id");

  const formHook = useForm<IFormValues>({
    mode: "onChange",
    defaultValues: { emr_images: [] },
  });

  const { watch } = formHook;

  const handleFileUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    setUploadingFiles(true);
    if (event.target.files && event.target.files.length > 0) {
      const files = Array.from(event.target.files);
      const uploadedImages = await Promise.all(
        files.map(async (file) => {
          const result = await uploadToS3(file, "emrid", "emr");
          if (result.status) {
            return result.message;
          }

          return null;
        }),
      );
      const validImages = uploadedImages.filter((img) => img !== null);
      const currentImages = formHook.getValues("emr_images") || [];
      const images: any = [...currentImages, ...new Set(validImages?.flat())];
      formHook.setValue("emr_images", images);
      const constructedBody = {
        attachments: images,
        emr_status: emrDetails?.emr_status,
      };
      await updateEmrAPI(emr_id, constructedBody).then(() => {
        setUploadingFiles(false);
      });

      if (currentImages) {
        // setIsImageRequired(false);
      }
    }
  };

  const handleDeleteProductImage = (imageIndex: number) => {
    const currentImages = formHook.getValues("emr_images") || [];
    const updatedImages = currentImages.filter((_, index) => index !== imageIndex);
    formHook.setValue("emr_images", updatedImages);
  };

  useEffect(() => {
    if (emrDetails) {
      formHook.setValue("emr_images", emrDetails?.attachments);
    }
  }, [emrDetails]);

  return (
    <div className="w-full bg-white p-3 rounded-[10px] mt-3">
      <h3 className="text-[#656565] text-sm font-medium tracking-tight42 px-2">Other Details</h3>

      <div className="bg-[#F9FAFB] w-full rounded-xl p-2 mt-2">
        <h3 className="text-[#000000] text-sm font-medium tracking-tight42 pb-2">Attachments</h3>
        <div className="md:col-span-2 p-2 bg-white rounded-xl border-dotted">
          <div className=" flex items-center justify-start b bg-white ">
            {uploadingFiles ? (
              <div className="flex items-center justify-center h-32 w-32 border rounded-lg">
                <svg
                  className="animate-spin h-6 w-6 text-gray-600"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                </svg>
              </div>
            ) : (
              <div className="flex items-center gap-6 flex-wrap bg-white">
                {formHook.watch("emr_images")?.map((image, index) => (
                  <div key={index} className="flex items-center justify-between flex-row">
                    <div className="flex flex-col gap-1 bg-white rounded-xl p-[10px]">
                      <div className="relative ">
                        <XMarkIcon
                          className="absolute -top-2 right-0 h-5 w-5 cursor-pointer text-white bg-red-500 rounded-full p-1"
                          onClick={() => handleDeleteProductImage(index)}
                        />
                        {image?.split(".")?.pop()?.toLowerCase() === "pdf" ? (
                          <>
                            <img
                              onClick={() => window.open(image, "_blank")}
                              src={
                                "https://vetic-img.s3.ap-south-1.amazonaws.com/quick_commerce//misc/pdf-svgrepo-com.svg"
                              }
                              alt={image}
                              className="h-[150px] w-[150px] object-cover rounded-lg"
                            />
                          </>
                        ) : (
                          <>
                            {" "}
                            <img
                              src={image}
                              onClick={() => window.open(image, "_blank")}
                              alt="Prescription"
                              className=" h-[120px] w-[120px] object-cover cursor-pointer rounded-lg"
                            />
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          <ImageUploadComponent
            handleFileChange={handleFileUpload}
            heading="Click to upload"
            text="or drag and drop PDF,JPEG,PNG up to 5MB"
            data={watch("emr_images")}
            required={false}
          />
        </div>
      </div>
    </div>
  );
};
export default ImageAttachmentComponent;
